<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="cash-outline"></ion-icon> Track Record</h4>
  </div>
  <div class="content-details">
    <div class="content-div mb-2">
      <div class="row">
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-12"
          [formGroup]="financialForm"
        >
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex" style="height: 85px">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Do you have an Entrepreneurship Cell, or any other
                    initiatives related to innovation and entrepreneurship in
                    the institution?
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Do you have an Entrepreneurship Cell, or any other
                      initiatives related to innovation and entrepreneurship in
                      the institution?
                    </h6>
                  </div>
                  <div class="col-lg-12 col-md-8 col-12">
                    <div>
                      <div class="mt-3">
                        <mat-radio-group
                          disabled="{{ showForm }}"
                          formControlName="iic"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsonechecked"
                          (change)="showOptionsone($event.value)"
                          [ngClass]="{
                            'is-invalid':
                              setting.iic.touched && setting.iic.errors
                          }"
                        >
                          <mat-radio-button value="true">Yes</mat-radio-button>
                          <mat-radio-button value="false">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="setting.iic.touched && setting.iic.errors"
                        >
                          <span *ngIf="setting.iic.errors.required"
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>

                      <div class="opt-div" [ngSwitch]="Optionsonechecked">
                        <div class="row" *ngSwitchCase="'true'">
                          <div class="col-lg-8 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >Please provide a brief write-up about the said
                                program and its impact in the last two years.
                                <span class="text-danger">*</span></mat-label
                              >
                              <textarea
                                matInput
                                placeholder="Brief about the said program"
                                formControlName="iicbrief"
                                readonly="{{ showForm }}"
                                (change)="
                                  setStatus($event, 'dedicatedAreaStatus', 0)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.iicbrief.touched &&
                                    setting.iicbrief.errors
                                }"
                              ></textarea>
                              <mat-error
                                *ngIf="
                                  setting.iicbrief.touched &&
                                  setting.iicbrief.errors
                                "
                              >
                                <span *ngIf="setting.iicbrief.errors.required"
                                  >Brief about the program is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button
                  mat-button
                  color="primary"
                  (click)="nextStep()"
                  *ngIf="!showForm"
                >
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Details of the 5 best practices related to innovation and
                    entrepreneurship done by host institution and their impact.
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="">
                  <div class="mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Details of the 5 best practices related to innovation and
                      entrepreneurship done by host institution and their
                      impact.
                    </h6>
                  </div>
                  <div class="content-details">
                    <div class="row">
                      <div
                        class="col-12"
                        *ngIf="!showForm && 4 >= bestpractices.length"
                      >
                        <button
                          class="btn btn-primary mb-3"
                          style="float: inline-end"
                          (click)="addBestpracticesRow2()"
                        >
                          Add Practice
                        </button>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div
                          class="table-responsive"
                          [formGroup]="financialForm"
                        >
                          <table class="table table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">No</th>
                                <th scope="col">Best Practice</th>
                                <th
                                  scope="col"
                                  class="text-center"
                                  *ngIf="!showForm"
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                *ngFor="
                                  let item of bestpractices.controls;
                                  let i = index
                                "
                                [formGroup]="item"
                              >
                                <th scope="row">{{ i + 1 }}</th>

                                <td>
                                  <input
                                    class="form-control"
                                    formControlName="bestpractice"
                                    [readonly]="showForm"
                                    [ngClass]="{
                                      'is-invalid':
                                        item.get('bestpractice').touched &&
                                        item.get('bestpractice').errors
                                    }"
                                    type="text"
                                    placeholder="Best Practice"
                                  />

                                  <div
                                    *ngIf="
                                      item.get('bestpractice').touched &&
                                      item.get('bestpractice').errors
                                    "
                                  >
                                    <span
                                      class="text-danger"
                                      *ngIf="
                                        item.get('bestpractice').errors.required
                                      "
                                    >
                                      Best Practice is required
                                    </span>
                                  </div>
                                </td>
                                <td class="text-center" *ngIf="!showForm">
                                  <i
                                    class="fas fa-trash delete-i ml-3"
                                    (click)="deleteRow(i, item.get('id').value)"
                                    aria-hidden="true"
                                  ></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row *ngIf="!showForm">
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Details of the latest 5 Events organized by the Host
                    Institution related to Innovation & Entrepreneurship
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Details of the latest 5 Events organized by the Host
                      Institution related to Innovation & Entrepreneurship
                    </h6>
                  </div>
                  <div class="content-details" [formGroup]="financialForm">
                    <div class="row">
                      <div class="col-12">
                        <div
                          class="d-flex w-100 mb-4"
                          *ngIf="!showForm && 4 >= events.length"
                        >
                          <div class="ml-auto">
                            <button
                              class="btn btn-primary"
                              (click)="addEventsRow2()"
                            >
                              Add Event
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <mat-expansion-panel
                          *ngFor="let item of events.controls; let i = index"
                          [formGroup]="item"
                          [expanded]="step3 === index"
                          (opened)="setStep3(index)"
                        >
                          <mat-expansion-panel-header class="d-flex">
                            <h6>{{ i + 1 }}.&nbsp; Event</h6>
                            <div class="ml-auto" *ngIf="!showForm">
                              <i
                                class="fas fa-trash delete-i mr-5"
                                (click)="deleteRow2(i, item.get('id').value)"
                                aria-hidden="true"
                              ></i>
                            </div>
                          </mat-expansion-panel-header>
                          <div class="answer-div">
                            <div class="content-details">
                              <div class="row">
                                <div class="col-lg-9 col-md-9 col-sm-12 col-12">
                                  <div class="form-rows">
                                    <mat-form-field
                                      class="material-full-width"
                                      appearance="outline"
                                    >
                                      <mat-label
                                        >Event Name
                                        <span class="text-danger"
                                          >*</span
                                        ></mat-label
                                      >
                                      <input
                                        matInput
                                        placeholder="Enter Event Name"
                                        formControlName="eventname"
                                        readonly="{{ showForm }}"
                                      />
                                      <mat-error
                                        *ngIf="
                                          item.get('eventname').touched &&
                                          item.get('eventname').errors
                                        "
                                      >
                                        <span
                                          *ngIf="
                                            item.get('eventname').errors
                                              .required
                                          "
                                          >Event Name is required</span
                                        >
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div
                                  class="col-lg-3 col-md-3 col-sm-12 col-12"
                                ></div>
                                <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                                  <div class="form-rows">
                                    <mat-form-field
                                      class="material-full-width"
                                      appearance="outline"
                                    >
                                      <mat-label
                                        >Topic
                                        <span class="text-danger"
                                          >*</span
                                        ></mat-label
                                      >
                                      <input
                                        matInput
                                        placeholder="Enter Topic"
                                        formControlName="topic"
                                        readonly="{{ showForm }}"
                                      />
                                      <mat-error
                                        *ngIf="
                                          item.get('topic').touched &&
                                          item.get('topic').errors
                                        "
                                      >
                                        <span
                                          *ngIf="
                                            item.get('topic').errors.required
                                          "
                                          >Topic is required</span
                                        >
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                                  <div class="form-rows">
                                    <mat-form-field
                                      class="material-full-width"
                                      appearance="outline"
                                    >
                                      <mat-label
                                        >Date
                                        <span class="text-danger"
                                          >*</span
                                        ></mat-label
                                      >
                                      <input
                                        matInput
                                        [matDatepicker]="picker"
                                        placeholder="Date (DD.MM.YYYY)"
                                        formControlName="date"
                                        [readonly]="showForm"
                                        (click)="picker.open()"
                                      />
                                      <mat-datepicker
                                        [disabled]="showForm"
                                        #picker
                                      ></mat-datepicker>
                                      <mat-error
                                        *ngIf="
                                          item.get('date').touched &&
                                          item.get('date').errors
                                        "
                                      >
                                        <span
                                          *ngIf="
                                            item.get('date').errors.required
                                          "
                                        >
                                          Date is required and must be in
                                          DD.MM.YYYY format
                                        </span>
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                                  <div class="form-rows">
                                    <mat-form-field
                                      class="material-full-width"
                                      appearance="outline"
                                    >
                                      <mat-label
                                        >Venue
                                        <span class="text-danger"
                                          >*</span
                                        ></mat-label
                                      >
                                      <input
                                        matInput
                                        placeholder="Enter Venue"
                                        formControlName="venue"
                                        readonly="{{ showForm }}"
                                      />
                                      <mat-error
                                        *ngIf="
                                          item.get('venue').touched &&
                                          item.get('venue').errors
                                        "
                                      >
                                        <span
                                          *ngIf="
                                            item.get('venue').errors.required
                                          "
                                          >Venue is required</span
                                        >
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>

                                <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                                  <div class="form-rows">
                                    <mat-form-field
                                      class="material-full-width"
                                      appearance="outline"
                                    >
                                      <mat-label
                                        >Funded By
                                        <span class="text-danger"
                                          >*</span
                                        ></mat-label
                                      >
                                      <input
                                        matInput
                                        placeholder="Enter Funded By"
                                        formControlName="fundedby"
                                        readonly="{{ showForm }}"
                                      />
                                      <mat-error
                                        *ngIf="
                                          item.get('fundedby').touched &&
                                          item.get('fundedby').errors
                                        "
                                      >
                                        <span
                                          *ngIf="
                                            item.get('fundedby').errors.required
                                          "
                                          >Funded By is required</span
                                        >
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                                  <div class="form-rows">
                                    <mat-form-field
                                      class="material-full-width"
                                      appearance="outline"
                                    >
                                      <mat-label
                                        >Amount
                                        <span class="text-danger"
                                          >*</span
                                        ></mat-label
                                      >
                                      <input
                                        matInput
                                        placeholder="Enter Amount"
                                        formControlName="amount"
                                        type="text"
                                        [readonly]="showForm"
                                        (input)="onAmountInput($event)"
                                      />
                                      <mat-error
                                        *ngIf="
                                          item.get('amount').touched &&
                                          item.get('amount').errors
                                        "
                                      >
                                        <span
                                          *ngIf="
                                            item.get('amount').errors.required
                                          "
                                          >Amount is required</span
                                        >
                                        <span
                                          *ngIf="
                                            item.get('amount').errors.pattern
                                          "
                                          >Invalid amount</span
                                        >
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                                  <div class="form-rows">
                                    <mat-form-field
                                      class="material-full-width"
                                      appearance="outline"
                                    >
                                      <mat-label
                                        >Details of Resource Person
                                        <span class="text-danger"
                                          >*</span
                                        ></mat-label
                                      >
                                      <input
                                        matInput
                                        placeholder="Enter Details of Resource Person"
                                        formControlName="resource"
                                        readonly="{{ showForm }}"
                                      />
                                      <mat-error
                                        *ngIf="
                                          item.get('resource').touched &&
                                          item.get('resource').errors
                                        "
                                      >
                                        <span
                                          *ngIf="
                                            item.get('resource').errors.required
                                          "
                                          >Details of Resource Person is
                                          required</span
                                        >
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                                  <div class="form-rows">
                                    <mat-form-field
                                      class="material-full-width"
                                      appearance="outline"
                                    >
                                      <mat-label
                                        >Measurable Outcome
                                        <span class="text-danger"
                                          >*</span
                                        ></mat-label
                                      >
                                      <input
                                        matInput
                                        placeholder="Enter Measurable Outcome"
                                        formControlName="measurableoutcome"
                                        readonly="{{ showForm }}"
                                      />
                                      <mat-error
                                        *ngIf="
                                          item.get('measurableoutcome')
                                            .touched &&
                                          item.get('measurableoutcome').errors
                                        "
                                      >
                                        <span
                                          *ngIf="
                                            item.get('measurableoutcome').errors
                                              .required
                                          "
                                          >Measurable Outcome is required</span
                                        >
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                                  <div class="form-rows">
                                    <mat-form-field
                                      class="material-full-width"
                                      appearance="outline"
                                    >
                                      <mat-label
                                        >No. of Participants
                                        <span class="text-danger"
                                          >*</span
                                        ></mat-label
                                      >
                                      <input
                                        matInput
                                        placeholder="Enter No. of Participants"
                                        type="text"
                                        formControlName="noofparticipants"
                                        readonly="{{ showForm }}"
                                        (input)="onAmountInput($event)"
                                      />
                                      <mat-error
                                        *ngIf="
                                          item.get('noofparticipants')
                                            .touched &&
                                          item.get('noofparticipants').errors
                                        "
                                      >
                                        <span
                                          *ngIf="
                                            item.get('noofparticipants').errors
                                              .required
                                          "
                                          >No. of Participants is required</span
                                        >
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </mat-expansion-panel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row *ngIf="!showForm">
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
